import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SR_API_ACTION_PARTNER_UNDO_LISTINGS_CSV_IMPORT,
} from 'api/actionTypes';

import branch from 'client/core/branch';
import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import log from 'client/lib/log';

@withApiState({
  partnerListingsUndoCsvImportApiState: {
    action: SR_API_ACTION_PARTNER_UNDO_LISTINGS_CSV_IMPORT,
  },
})
@branch()
class SrPartnerCsvListingsUndo extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  _onCtaClick = () => {
    const { dispatch } = this.props;
    const dataImportIdStr = global.prompt('Which data import ID?');

    if (!dataImportIdStr || isNaN(dataImportIdStr)) {
      return;
    }

    const dataImportId = parseInt(dataImportIdStr, 10);
    if (!global.confirm(`Are you sure you want to undo data import ${dataImportId}?`)) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_UNDO_LISTINGS_CSV_IMPORT,
      payload: {
        dataImportId,
      },
      onSuccess() {
        global.alert('Ok.');
      },
      onError(error) {
        log.error(error);
        global.alert(`ERROR: ${error.message}`);
      },
    });
  }

  render() {
    const {
      partnerListingsUndoCsvImportApiState,
    } = this.props;

    return (
      <ButtonDeprecated
        type='button'
        onClick={this._onCtaClick}
        disabled={partnerListingsUndoCsvImportApiState.inProgress}
      >
        {partnerListingsUndoCsvImportApiState.inProgress
          ? 'Please wait...'
          : 'Undo Data Import'
        }
      </ButtonDeprecated>
    );
  }
}

SrPartnerCsvListingsUndo.displayName = 'SrPartnerCsvListingsUndo';

export default SrPartnerCsvListingsUndo;
